import ErrorTip from '@/utils/class/ErrorTip'

/**
 * 页签抽象类
 */
export default class PageAbstract {
  constructor(job, formData) {
    this.job = job
    this.formData = formData || {}
    this.elementMap = new Map()
    this.jobWatchList = []
    this.formWatchList = []
    this.fieldWatchList = []
  }

  async loadElement(elementName) {
    throw new ErrorTip('子类必须实现loadElement方法')
  }

  get(elementName) {
    return this.elementMap.get(elementName)
  }

  /**
   * 加入job监听列表
   * @param {Function} callback 回调函数
   */
  joinJobWatchList(callback) {
    this.jobWatchList.push(callback)
  }

  /**
   * 加入formData监听列表
   * @param {Function} callback 回调函数
   */
  joinFormWatchList(callback) {
    this.formWatchList.push(callback)
  }

  /**
   * 加入字段监听列表
   * @param {string} field 字段名
   * @param {Function} callback 回调函数
   */
  joinFieldWatchList(field, callback) {
    let item = this.fieldWatchList.find(item => item.field === field)
    if (!item) {
      item = { field, value: this.getFiledValue(field), callbacks: [] }
      this.fieldWatchList.push(item)
    }
    item.callbacks.push(callback)
  }

  /**
   * 获取字段值
   * @param {string} field 字段名
   * @returns {any} 字段值
   */
  getFiledValue(field) {
    if (field.startsWith('job.')) {
      return this.job[field.replace('job.', '')]
    }
    return this.formData[field]
  }

  /**
   * 处理字段值变化
   * @returns {Promise<boolean>} 是否发生变化
   */
  async handleFieldChange() {
    let hasChange = false
    const funcSet = new Set()
    for (const watch of this.fieldWatchList) {
      const newValue = this.getFiledValue(watch.field)
      if (newValue !== watch.value) {
        for (const callback of watch.callbacks) {
          if (funcSet.has(callback)) {
            continue
          }
          const funResult = callback()
          if (funResult instanceof Promise) {
            await funResult
          }
          funcSet.add(callback)
        }
        hasChange = true
      }
      watch.value = newValue
    }
    return hasChange
  }

  /**
   * 触发所有change处理（job、formData、字段值）
   * @returns {Promise<boolean>} 是否发生变化
   */
  async triggerAllChange() {
    let hasChange = false
    const funcSet = new Set()
    for (const callback of this.jobWatchList) {
      if (funcSet.has(callback)) {
        continue
      }
      const funResult = callback()
      if (funResult instanceof Promise) {
        await funResult
      }
      funcSet.add(callback)
      hasChange = true
    }
    for (const callback of this.formWatchList) {
      if (funcSet.has(callback)) {
        continue
      }
      const funResult = callback()
      if (funResult instanceof Promise) {
        await funResult
      }
      funcSet.add(callback)
      hasChange = true
    }
    for (const watch of this.fieldWatchList) {
      for (const callback of watch.callbacks) {
        if (funcSet.has(callback)) {
          continue
        }
        const funResult = callback()
        if (funResult instanceof Promise) {
          await funResult
        }
        funcSet.add(callback)
      }
      hasChange = true
      watch.value = this.getFiledValue(watch.field)
    }
    return hasChange
  }
}
